import {fullScreenContainer, scrollBoard} from "@jiaminghi/data-view"


export default {
    install(V) {
        V.use(fullScreenContainer);
        V.use(scrollBoard);
    }
}